import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PartService from "../../../Parts/Controller/PartController";
import HelpSite from "../../../Common/HelpLink";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import Draggable from 'react-draggable';
import { handleChange, handleSubmit } from "../../Controller/CreatePurchaseOrderController";
import SupplierService from "../../../Supplier/Controller/SupplierController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import SupplierContactService from "../../../Supplier/Controller/SupplierContactController";
import { convertCurrency } from "./CurrencyConverter";

function ShortFallPartPage({ onClose, shorFallPartList, SupplierList }) {
    const navigate = useNavigate();
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const tableRef = useRef();
    const HelpLink = localStorage.getItem('HelpLink');
    const [selectedId, setSelectedId] = useState(null);
    const [errors, setErrors] = useState({});
    const [partList, setPartData] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [filteredShortFallParts, setFilteredShortFallParts] = useState(shorFallPartList); // First table data
    const [movedParts, setMovedParts] = useState([]);
    const [movedPartIds, setMovedPartIds] = useState([]);
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [currencyList, setCurrencies] = useState([]);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    useEffect(() => {

    }, [filteredShortFallParts, movedParts]);

    useEffect(() => {
        fetchDefaultCurrency();
        fetchCurrency();
    }, [SupplierList]);
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const [formData, setFormData] = useState({
        CustomerID: 0,
        CustomerName: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        FK_Supplier_ID: 0,
        FK_SupplierContact_ID: "0",
        vc_SupplierName: "",
        vc_AccountRef: "",
        vc_SupplierInvoice: "",
        vc_User7: "",
        AccountRef: '',
        dec_DiscountAmount: "0.00",
        mon_TotalPrice: "0.00",
        GrandTotal: "0.00",
        dec_DiscountNETTotal: "0.00",
        vc_CustomerOrderNumber: "",
        dt_PurchaseOrderDate: getCurrentDate(),
        int_DiscountType: 0,
        FK_Currency_ID: "0",
        IsPercentage: false,
        mon_TotalPriceO: "0.00",
        mon_TotalPriceGR: "0.00",
        FK_Issue_ID: "0",
        vc_User5: "",
        snt_PaymentMethod: "0",
        FK_SalesOrderType_ID: "0",
        type: "0",
        ConversionAmount: "1.00",

        HostCompanyAddress: "",
        POrderNo: "",
        Supp_Address1: "",
        Supp_City: "",
        Supp_County: "",
        Supp_Postcode: "",
    });

    const handleCheckboxChange = (event, id) => {
        if (event.target.checked) {
            setSelectedIds((prev) => [...prev, id]);
        } else {
            setSelectedIds((prev) => prev.filter((selectedId) => selectedId !== id));
        }
        console.log("Updated selectedIds:", selectedIds);
    };
    useEffect(() => {
        // Filter out parts that are already moved to the second table
        const updatedFilteredParts = shorFallPartList.filter(
            (part) => !movedParts.some((movedPart) => movedPart.PK_Stock_ID === part.PK_Stock_ID)
        );
        setFilteredShortFallParts(updatedFilteredParts);
    }, [movedParts, shorFallPartList]);
    useEffect(() => {
        debugger;
        if (shorFallPartList.length > 0 && SupplierList.length > 0) {
            const partsToMove = [];
            const remainingParts = [];
    
            shorFallPartList.forEach((part) => {
                if (parseFloat(part.mon_StockPrice) < parseFloat(part.ActualStockPrice)) {
                    partsToMove.push({
                        ...part,
                        PrefeeredSuppliers: part.PrefeeredSuppliers, // Use existing supplier name
                        FK_Supplier_ID: part.SuppID || 0,    // Ensure valid Supplier ID
                        SuppID: part.SuppID || null,                // Add SuppID
                    });
                } else {
                    remainingParts.push(part);
                }
            });
    
            // Update the states
            setMovedParts(partsToMove); // Initialize moved parts
            setFilteredShortFallParts(remainingParts); // Filter out moved parts
        }
    }, [shorFallPartList, SupplierList]);
    const isCheckboxSelected = (id) => {
        return selectedIds.includes(id); // Correctly check if the id is in the selectedIds array
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[1, 'desc']],
            columnDefs: [
                { orderable: false, targets: 0 } // Disable sorting on the first column
            ],
            pageLength: getPageSizeFromCookie(), // Set initial page size
        }).on('length.dt', function (e, settings, len) {
            setPageSizeInCookie(len); // Save page size to cookie on change
        });
    };
    /*useEffect(() => {
        if (shorFallPartList.length > 0) {
            initDataTable();
        }
    }, [shorFallPartList]);*/

    const fetchShortFallSupplier = async (SupplierID) => {
        try {
            // setFilteredShortFallParts(shorFallPartList);
            setPartData([]);
            const list = await PartService.ShortFallPartsBySupplierID(SupplierID);
            setPartData(list);

        }
        catch (error) {
            console.error('Error fetching Teams:', error);
        }

    }

    const handleFieldChange = (event) => {
        const { name, value } = event.target;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));

        if (name === "FK_Supplier_ID") {
            debugger;
            fetchShortFallSupplier(value);
            updateSelectedRecords(value);
        }
    };
    const updateSelectedRecords = (supplierID) => {
        debugger;
        if (!supplierID) return;
        const matchingRecords = shorFallPartList.filter((part) =>
            part.SuppID.split(",").map((id) => id.trim()).includes(supplierID)
        );

        const matchingIds = matchingRecords.map((record) => record.PK_Stock_ID);

        setSelectedIds((prevSelectedIds) => {
            // Ensure only IDs of matching records are set
            return prevSelectedIds === matchingIds ? null : matchingIds;
        });
    };

    const truncateText = (text, maxLength = 20) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const moveSelectedParts = () => {
        if (!formData.FK_Supplier_ID || formData.FK_Supplier_ID <= 0) {
            Swal.fire({
                icon: "error",
                title: "Invalid Operation",
                text: "Please select a valid supplier before moving parts.",
            });
            return;
        }
        debugger;
        const selectedSupplier = SupplierList.find(
            (supplier) => supplier.PK_Supplier_ID === parseInt(formData.FK_Supplier_ID)
        );

        if (!selectedSupplier) {
            Swal.fire({
                icon: "error",
                title: "Invalid Supplier",
                text: "Selected supplier is invalid or not found.",
            });
            return;
        }

        const partsToMove = filteredShortFallParts
            .filter((part) => selectedIds.includes(part.PK_Stock_ID))
            .map((part) => ({
                ...part,
                PrefeeredSuppliers: selectedSupplier.vc_SupplierName, // Update Preferred Supplier
                FK_Supplier_ID: selectedSupplier.PK_Supplier_ID, // Update Supplier ID
            }));



        if (partsToMove.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Selection",
                text: "Please select at least one part to move.",
            });
            return;
        }

        setMovedParts((prev) =>
            [...prev, ...partsToMove].sort((a, b) => a.FK_Supplier_ID - b.FK_Supplier_ID)
        );
        setFilteredShortFallParts((prev) =>
            prev.filter((part) => !selectedIds.includes(part.PK_Stock_ID))
        );
        setSelectedIds([]); // Clear selected IDs
    };

    const handleSave = async (event) => {

        if (movedParts.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "No Data",
                text: "There are no parts to submit.",
            });
            return;
        }

        // Group movedParts by Supplier ID
        const groupedBySupplier = movedParts.reduce((acc, part) => {
            if (!acc[part.FK_Supplier_ID]) {
                acc[part.FK_Supplier_ID] = [];
            }
            acc[part.FK_Supplier_ID].push(part);
            return acc;
        }, {});

        const redirectCallback = () => navigate('/');
        // Submit each group
        let IsMessage = "0";
        for (const supplierId in groupedBySupplier) {


            const supplierData = await SupplierService.GetSupplierByID(redirectCallback, supplierId);
            const SupplierContact = await SupplierContactService.GetAllSupplierContacts(redirectCallback, supplierId);

            let ConvRate = "1.00";
            ConvRate = await convertCurrency(BaseCurrency, supplierData[0].vc_CurrencySymbol, currencyList, "0");
            const partsForSupplier = groupedBySupplier[supplierId];

            const payload = partsForSupplier.map(item => ({
                vc_StockCode: item.vc_StockCode,
                vc_Description: item.vc_Description,
                mon_StockPrice: item.mon_StockPrice, // Use the converted price
                mon_SalesPrice: item.mon_SalesPrice,
                vc_UnitOfSale: item.dec_MinimumQuantity - item.dec_FreeStock,
                net_SalesPrice: (item.mon_StockPrice * (item.dec_MinimumQuantity - item.dec_FreeStock)),
                net_VATPrice: item.net_VATPrice,
                vc_StockName: item.vc_Description,
                PK_Stock_ID: item.FK_Stock_ID,
                dec_Discount: item.dec_Discount,
                // mon_SellingPrice: convertedmon_SellingPrice,
                vc_CommodityCode: item.vc_CommodityCode,
                dec_TaxCode: item.dec_TaxCode,
                dec_UnitWeight: item.dec_UnitWeight,
                snt_PurchaseNominalCode: item.snt_PurchaseNominalCode,
                dec_VAT: item.dec_VAT,
                mon_VATPriceForeignCurrency: item.mon_VATPriceForeignCurrency,
                PK_Stock_ID: item.PK_Stock_ID,

            }));
            let SupplierContact_ID = "0";
            if (SupplierContact.length > 0) {
                SupplierContact_ID = SupplierContact[0].PK_SupplierContact_ID;
            }
            const data = {
                CustomerID: 0,
                CustomerName: '',
                FK_ClientBranch_ID: 0,
                FK_ClientContact_ID: 0,
                FK_Supplier_ID: supplierId,
                FK_SupplierContact_ID: SupplierContact_ID,
                vc_SupplierName: "",
                vc_AccountRef: "",
                vc_SupplierInvoice: "",
                vc_User7: "",
                AccountRef: '',
                dec_DiscountAmount: "0.00",
                mon_TotalPrice: "0.00",
                GrandTotal: "0.00",
                dec_DiscountNETTotal: "0.00",
                vc_CustomerOrderNumber: "",
                dt_PurchaseOrderDate: getCurrentDate(),
                int_DiscountType: 0,
                FK_Currency_ID: "0",
                IsPercentage: false,
                mon_TotalPriceO: "0.00",
                mon_TotalPriceGR: "0.00",
                FK_Issue_ID: "0",
                vc_User5: "",

                FK_SalesOrderType_ID: "0",
                type: "0",
                ConversionAmount: "1.00",
                HostCompanyAddress: "",
                POrderNo: "",
                Supp_Address1: "",
                Supp_City: "",
                Supp_County: "",
                Supp_Postcode: "",
                FK_PurchaseOrderStatus_ID: "2",
                FK_PurchaseOrderType_ID: "1",
                snt_PurchaseType: "1",
                snt_PaymentMethod: "4",
                BaseCurrency: BaseCurrency,
                currencySupplierSymbol1: supplierData[0].vc_CurrencySymbol
            };
            debugger;
            const formDataWithParts = {
                formData: data,
                selectedParts: payload
            };
            
            const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);
            if (message == "Data saved successfully") {

                IsMessage = "1";

            }
        }
        if (IsMessage === "1") {
            const redirectUserList = () => {
                navigate('/PurchasingList?saved=true');
            };
            localStorage.setItem('HasRecordUpdated', "1");
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Data saved Successfully.",
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });

            onClose();
            redirectUserList();
        }
    };

    const handleRemove = (partId) => {
        // Find the part to remove from the movedParts array
        const partToRemove = movedParts.find((part) => part.PK_Stock_ID === partId);

        if (partToRemove) {
            // Update the movedParts state to exclude the removed part
            setMovedParts((prev) =>
                prev.filter((part) => part.PK_Stock_ID !== partId)
            );

            // Add the removed part back to the first table
            setFilteredShortFallParts((prev) => [...prev, partToRemove].sort((a, b) => a.PK_Stock_ID - b.PK_Stock_ID));
        }
    };
    return (
        <div>
            <div className="modal fade shortFallModal show d-block" id="shortFallModal" tabIndex="-1" aria-labelledby="shortFallModalLabel" aria-hidden="true" data-backdrop="static">

                <div className="modal-dialog modal-xl">
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h6 className="modal-title" id="largeModalLabel">Purchase Ordering and Product Shortfalls</h6>
                                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div style={{ "marginLeft": "5px", "marginRight": "5px", "marginTop": "10px" }}>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                        <label htmlFor="vc_StockCode" className="col-sm-2 col-form-label">Supplier:</label>
                                        <div className="col-sm-4">
                                            <select name="FK_Supplier_ID" className='form-control' value={formData.FK_Supplier_ID} onChange={handleFieldChange}>
                                                <option value="0">No Prefferable Supplier</option>
                                                {SupplierList.map((supplier) => (
                                                    <option key={supplier.PK_Supplier_ID} value={supplier.PK_Supplier_ID}>
                                                        {supplier.vc_SupplierName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_Supplier_ID && <div style={{ "color": "red", "fontsize": "0.8vw" }}>{errors.FK_Supplier_ID}</div>}
                                        </div>

                                    </div>

                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "5px" }}>
                                        <div className="col-sm-6" style={{ minHeight: "300px", overflow: "auto" }}>
                                            <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th className="no-wrap">Product Code</th>
                                                        <th className="no-wrap">Preferred Supplier(s)</th>
                                                        <th className="no-wrap">Cost Price</th>
                                                        <th className="no-wrap">Required Quantity</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredShortFallParts.map((part, index) => (
                                                        <tr key={part.PK_Stock_ID}>
                                                            <td style={{ "width": "10%" }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isCheckboxSelected(part.PK_Stock_ID)}
                                                                    onChange={(event) => handleCheckboxChange(event, part.PK_Stock_ID)}
                                                                />
                                                            </td>
                                                            <td className="no-wrap" style={{ "width": "20%" }}>{part.vc_StockCode}</td>
                                                            <td className="no-wrap" style={{ "width": "30%" }}>{truncateText(part.PrefeeredSuppliers)}</td>
                                                            <td className="no-wrap" style={{ "width": "20%" }}>
                                                                {part.Symbol}
                                                                {part.mon_StockPrice}
                                                            </td>
                                                            <td style={{ "width": "20%" }}>
                                                                {part.dec_MinimumQuantity - part.dec_FreeStock} {part.Measurment}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="col-sm-1 d-flex flex-column align-items-center justify-content-center">


                                            <button className="btn btn-primary" onClick={moveSelectedParts}>
                                                &gt;&gt;
                                            </button>
                                        </div>
                                        <div className="col-sm-5" style={{ minHeight: "300px", overflow: "auto" }}>
                                            <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                                <thead>
                                                    <tr>

                                                        <th style={{ "width": "20%" }} className="no-wrap">Product Code</th>
                                                        <th style={{ "width": "30%" }} className="no-wrap">Supplier</th>
                                                        <th style={{ "width": "20%" }} className="no-wrap">Cost Price</th>
                                                        <th style={{ "width": "20%" }} className="no-wrap">Required Quantity</th>
                                                        <th style={{ "width": "10%", "textAlign": "right" }} className="no-wrap">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {movedParts.map((part) => (
                                                        <tr key={part.PK_Stock_ID}>
                                                            <td>{part.vc_StockCode}</td>
                                                            <td className="no-wrap">{part.PrefeeredSuppliers}</td>
                                                            <td>{part.Symbol}{part.mon_StockPrice} </td>
                                                            <td>{part.dec_MinimumQuantity - part.dec_FreeStock} {part.Measurment}</td>

                                                            <td style={{ "textAlign": "right" }}>
                                                                <button className="text-danger" style={{ "background": "none", "border": "none" }}
                                                                    onClick={() => handleRemove(part.PK_Stock_ID)}>
                                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-8">

                                        </div>
                                        <div className="col-sm-4">
                                            <button type="submit" className="btn btn-primary" style={{ "float": "right" }} onClick={(event) => handleSave(event)}>
                                                <i className="icofont-save" aria-hidden="true">
                                                    Save
                                                </i>
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
            </div >
        </div>


    );
}
export default ShortFallPartPage;

